import { ASYNC_STATUS_ID } from 'constants/index'
import { API } from 'constants/apiEndPoints'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useAPI } from 'utils/hooks/useAPI'
import { isEmpty } from 'lodash'

export const useUserPublicData = (account) => {
  const [data, setData] = useState({})
  const [isPending, setPending] = useState(true)
  const [isError, setError] = useState(false)

  const [apiState, sendApiQuery, hasApiStatus, resetApiStatus] = useAPI(
    API.ACCOUNT_LVG_OVERVIEW,
    { queryType: 'get', withJwt: true, controlled: true }
  )

  const [
    apiRedditState,
    sendRedditApiQuery,
    hasRedditApiStatus,
    resetRedditStatus,
  ] = useAPI(API.ACCOUNT_REDDIT_INFO, {
    queryType: 'get',
    withJwt: true,
    controlled: true,
  })

  const refreshData = useCallback(() => {
    setPending(true)
    sendApiQuery({ params: { address: account } })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account])

  useEffect(() => {
    refreshData()
  }, [refreshData])

  useEffect(() => {
    if (hasApiStatus(ASYNC_STATUS_ID.ERROR)) {
      console.log('ACZ: Overview error')
      resetRedditStatus()
      resetApiStatus()
      setError(true)
    }

    if (hasApiStatus(ASYNC_STATUS_ID.CONFIRMED)) {
      if (!Object.keys(apiState.data).length) return null
      const data = apiState.data
      sendRedditApiQuery({ params: { address: account }, tunnel: data })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiState.status?.id, apiState?.data])

  useEffect(() => {
    let overviewData = null,
      redditData = null
    if (hasRedditApiStatus(ASYNC_STATUS_ID.CONFIRMED)) {
      if (isEmpty(Object.keys(apiRedditState.data))) return null
      if (apiRedditState.data.statusCode === 400)
        overviewData = apiRedditState.data.tunnel
      else if (!apiRedditState.data.statusCode) {
        const { tunnel, ...redditApiData } = apiRedditState.data
        redditData = redditApiData
        overviewData = tunnel
      } else {
        console.log('ACZ: Reddit error')
        resetRedditStatus()
        resetApiStatus()
        setError(true)
        return
      }
      setData({ overviewData, redditData })
      resetRedditStatus()
      resetApiStatus()
      setPending(false)
      return
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiRedditState.status?.id, apiRedditState?.data])

  return { isPending, isError, userPublicData: data, refreshData }
}
